import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpService } from "../http.service";
import { ServiceBase } from "../servicebase";
import { WorkHealthClinicModel } from "services/models/hiring/work-health-clinic.model";
import { Observable } from "rxjs";

@Injectable()
export class WorkHealthClinicService extends ServiceBase<WorkHealthClinicModel> {
  constructor(http: HttpService) {
    super("workhealthclinic", http, environment.apiUrl);
  }

  createEntity(input: any): WorkHealthClinicModel {
    return WorkHealthClinicModel.create(input);
  }

  listByCompany(companyId: string): Observable<WorkHealthClinicModel[]> {
    return new Observable<WorkHealthClinicModel[]>((observer) => {
      this.http
        .get(`${this.endpoint}/list-by-company/${companyId}`)
        .subscribe((res) => {
          observer.next(res.body);
          observer.complete();
        });
    });
  }
}
